import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

export const CrossSalesRevenue = ({ data }: any) => {
  // ✅ Extract values safely
  const percentages = data?.Percentages?.[0] || null;
  
  const chartData = percentages
    ? [
        { name: "T-shirt", y: percentages.TShirtPercentage ?? 0 },
        { name: "Medal", y: percentages.MedalPercentage ?? 0 },
        { name: "Delivery", y: percentages.DeliveryPercentage ?? 0 },
        { name: "Insurance", y: percentages.InsurancePercentage ?? 0 },
      ]
    : [];

  const options: Highcharts.Options = {
    chart: {
      type: "pie",
    },
    title: {
      text: "Cross Sales Revenue Distribution",
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.y:.2f}%</b>",
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    credits:{
           enabled: false
        },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format: "<b>{point.name}</b>: {point.percentage:.1f} %",
        },
      },
    },
    colors: ["#00BFFF", "#FFD700", "#FF6347", "#90EE90"], // Delivery, T-shirt, Medal, Insurance
    series: [
      {
        name: "Revenue",
        type: "pie",
        data: chartData,
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};
